import { render, staticRenderFns } from "./RecipeForm.vue?vue&type=template&id=276e288c&scoped=true&"
import script from "./RecipeForm.vue?vue&type=script&lang=js&"
export * from "./RecipeForm.vue?vue&type=script&lang=js&"
import style0 from "./RecipeForm.vue?vue&type=style&index=0&id=276e288c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e288c",
  null
  
)

export default component.exports